"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authorizationSaga = exports.createAuthorizationSaga = void 0;

var effects_1 = require("redux-saga/effects");

var multicall_1 = require("@0xsequence/multicall");

var ethers_1 = require("ethers");

var decentraland_transactions_1 = require("decentraland-transactions");

var eth_1 = require("../../lib/eth");

var utils_1 = require("./utils");

var actions_1 = require("./actions");

var types_1 = require("./types");

var utils_2 = require("../wallet/utils");

function createAuthorizationSaga() {
  var _marked = /*#__PURE__*/_regeneratorRuntime.mark(handleFetchAuthorizationsRequest),
      _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(handleGrantTokenRequest),
      _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(handleRevokeTokenRequest);

  return /*#__PURE__*/_regeneratorRuntime.mark(function authorizationSaga() {
    return _regeneratorRuntime.wrap(function authorizationSaga$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return effects_1.takeEvery(actions_1.FETCH_AUTHORIZATIONS_REQUEST, handleFetchAuthorizationsRequest);

          case 2:
            _context.next = 4;
            return effects_1.takeEvery(actions_1.GRANT_TOKEN_REQUEST, handleGrantTokenRequest);

          case 4:
            _context.next = 6;
            return effects_1.takeEvery(actions_1.REVOKE_TOKEN_REQUEST, handleRevokeTokenRequest);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, authorizationSaga);
  });

  function handleFetchAuthorizationsRequest(action) {
    var _this = this;

    var authorizations, promises, multicallProviders, _iterator, _step, _loop, authorizationsToStore;

    return _regeneratorRuntime.wrap(function handleFetchAuthorizationsRequest$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            authorizations = action.payload.authorizations;
            _context4.prev = 1;
            promises = [];
            multicallProviders = {};
            _iterator = _createForOfIteratorHelper(authorizations);
            _context4.prev = 5;
            _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
              var authorization, chainId, provider, ethersProvider, multicallProvider, erc20, erc721;
              return _regeneratorRuntime.wrap(function _loop$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      authorization = _step.value;

                      if (utils_1.isValidType(authorization.type)) {
                        _context3.next = 3;
                        break;
                      }

                      throw new Error("Invalid authorization type ".concat(authorization.type));

                    case 3:
                      chainId = authorization.chainId;

                      if (multicallProviders[chainId]) {
                        _context3.next = 11;
                        break;
                      }

                      _context3.next = 7;
                      return effects_1.call(function () {
                        return eth_1.getNetworkProvider(chainId);
                      });

                    case 7:
                      provider = _context3.sent;
                      ethersProvider = new ethers_1.providers.Web3Provider(provider);
                      multicallProvider = new multicall_1.providers.MulticallProvider(ethersProvider);
                      multicallProviders[chainId] = multicallProvider;

                    case 11:
                      _context3.t0 = authorization.type;
                      _context3.next = _context3.t0 === types_1.AuthorizationType.ALLOWANCE ? 14 : _context3.t0 === types_1.AuthorizationType.APPROVAL ? 17 : 20;
                      break;

                    case 14:
                      erc20 = new ethers_1.Contract(authorization.contractAddress, ['function allowance(address owner, address spender) view returns (uint256)'], multicallProviders[chainId]);
                      promises.push( // @ts-ignore
                      erc20.allowance(authorization.address, authorization.authorizedAddress).then(function (allowance) {
                        return allowance.gt(0) ? authorization : null;
                      }).catch(function (error) {
                        console.warn("Error fetching allowance", authorization, error);
                        return null;
                      }));
                      return _context3.abrupt("break", 20);

                    case 17:
                      erc721 = new ethers_1.Contract(authorization.contractAddress, ['function isApprovedForAll(address owner, address operator) view returns (bool)'], multicallProviders[chainId]);
                      promises.push( // @ts-ignore
                      erc721.isApprovedForAll(authorization.address, authorization.authorizedAddress).then(function (isApproved) {
                        return isApproved ? authorization : null;
                      }).catch(function (error) {
                        console.warn("Error fetching approval", authorization, error);
                        return null;
                      }));
                      return _context3.abrupt("break", 20);

                    case 20:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _loop);
            });

            _iterator.s();

          case 8:
            if ((_step = _iterator.n()).done) {
              _context4.next = 12;
              break;
            }

            return _context4.delegateYield(_loop(), "t0", 10);

          case 10:
            _context4.next = 8;
            break;

          case 12:
            _context4.next = 17;
            break;

          case 14:
            _context4.prev = 14;
            _context4.t1 = _context4["catch"](5);

            _iterator.e(_context4.t1);

          case 17:
            _context4.prev = 17;

            _iterator.f();

            return _context4.finish(17);

          case 20:
            _context4.next = 22;
            return effects_1.call(function () {
              return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var results;
                return _regeneratorRuntime.wrap(function _callee$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.next = 2;
                        return Promise.all(promises);

                      case 2:
                        results = _context2.sent;
                        return _context2.abrupt("return", results.filter(function (result) {
                          return !!result;
                        }));

                      case 4:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee);
              }));
            });

          case 22:
            authorizationsToStore = _context4.sent;
            _context4.next = 25;
            return effects_1.put(actions_1.fetchAuthorizationsSuccess(authorizationsToStore));

          case 25:
            _context4.next = 31;
            break;

          case 27:
            _context4.prev = 27;
            _context4.t2 = _context4["catch"](1);
            _context4.next = 31;
            return effects_1.put(actions_1.fetchAuthorizationsFailure(authorizations, _context4.t2.message));

          case 31:
          case "end":
            return _context4.stop();
        }
      }
    }, _marked, null, [[1, 27], [5, 14, 17, 20]]);
  }

  function handleGrantTokenRequest(action) {
    var authorization, txHash;
    return _regeneratorRuntime.wrap(function handleGrantTokenRequest$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            authorization = action.payload.authorization;
            _context5.prev = 1;
            _context5.next = 4;
            return effects_1.call(function () {
              return changeAuthorization(authorization, types_1.AuthorizationAction.GRANT);
            });

          case 4:
            txHash = _context5.sent;
            _context5.next = 7;
            return effects_1.put(actions_1.grantTokenSuccess(authorization, authorization.chainId, txHash));

          case 7:
            _context5.next = 13;
            break;

          case 9:
            _context5.prev = 9;
            _context5.t0 = _context5["catch"](1);
            _context5.next = 13;
            return effects_1.put(actions_1.grantTokenFailure(authorization, _context5.t0.message));

          case 13:
          case "end":
            return _context5.stop();
        }
      }
    }, _marked2, null, [[1, 9]]);
  }

  function handleRevokeTokenRequest(action) {
    var authorization, txHash;
    return _regeneratorRuntime.wrap(function handleRevokeTokenRequest$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            authorization = action.payload.authorization;
            _context6.prev = 1;
            _context6.next = 4;
            return effects_1.call(function () {
              return changeAuthorization(authorization, types_1.AuthorizationAction.REVOKE);
            });

          case 4:
            txHash = _context6.sent;
            _context6.next = 7;
            return effects_1.put(actions_1.revokeTokenSuccess(authorization, authorization.chainId, txHash));

          case 7:
            _context6.next = 13;
            break;

          case 9:
            _context6.prev = 9;
            _context6.t0 = _context6["catch"](1);
            _context6.next = 13;
            return effects_1.put(actions_1.revokeTokenFailure(authorization, _context6.t0.message));

          case 13:
          case "end":
            return _context6.stop();
        }
      }
    }, _marked3, null, [[1, 9]]);
  }

  function changeAuthorization(authorization, action) {
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var contract, amount, isApproved;
      return _regeneratorRuntime.wrap(function _callee2$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (utils_1.isValidType(authorization.type)) {
                _context7.next = 2;
                break;
              }

              throw new Error("Invalid authorization type ".concat(authorization.type));

            case 2:
              contract = Object.assign(Object.assign({}, decentraland_transactions_1.getContract(authorization.contractName, authorization.chainId)), {
                address: authorization.contractAddress
              });
              _context7.t0 = authorization.type;
              _context7.next = _context7.t0 === types_1.AuthorizationType.ALLOWANCE ? 6 : _context7.t0 === types_1.AuthorizationType.APPROVAL ? 8 : 10;
              break;

            case 6:
              amount = action === types_1.AuthorizationAction.GRANT ? utils_1.getTokenAmountToApprove().toString() : '0';
              return _context7.abrupt("return", utils_2.sendTransaction(contract, function (erc20) {
                return erc20.approve(authorization.authorizedAddress, amount);
              }));

            case 8:
              isApproved = action === types_1.AuthorizationAction.GRANT;
              return _context7.abrupt("return", utils_2.sendTransaction(contract, function (erc712) {
                return erc712.setApprovalForAll(authorization.authorizedAddress, isApproved);
              }));

            case 10:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee2);
    }));
  }
}

exports.createAuthorizationSaga = createAuthorizationSaga;
exports.authorizationSaga = createAuthorizationSaga();